import React from "react";
import { useParams, useSearchParams } from "react-router";
import { DriveBasePage } from "../driveBasePage";
import { useGetFileDetailsQuery } from "@/api/files";
import { useDriveList } from "../hooks/use-drive-list";
import { useDriveSearch } from "../hooks/use-drive-search";
import TopBarProgress from "react-topbar-progress-indicator";

export const SubfolderDriveView: React.FC = () => {
  const { fseId: folderId } = useParams<{ fseId: string }>();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q");

  if (query) {
    return <SubfolderDrivePageSearch folderId={folderId || ""} query={query} />;
  } else {
    return <SubfolderDrivePageDefault folderId={folderId || ""} />;
  }
};

interface SubfolderDrivePageSearchProps {
  folderId: string;
  query: string;
}

const SubfolderDrivePageSearch: React.FC<SubfolderDrivePageSearchProps> = ({ folderId, query }) => {
  const { isLoading, error, displayItems, totalPages, setCurrentPage, itemsPerPage, currentPage } = useDriveSearch({
    query,
    folderId,
    entry_type: ["file"],
  });
  const { data, isLoading: isLoadingDetails } = useGetFileDetailsQuery({ fse_id: folderId });

  return (
    <DriveBasePage
      totalPages={totalPages}
      setCurrentPage={setCurrentPage}
      itemsPerPage={itemsPerPage}
      currentPage={currentPage}
      isLoading={isLoading || isLoadingDetails}
      error={error}
      displayItems={displayItems}
      isRootDirectory={false}
      data={data}
      folderId={folderId}
    />
  );
};

interface SubfolderDrivePageDefaultProps {
  folderId: string;
}

const SubfolderDrivePageDefault: React.FC<SubfolderDrivePageDefaultProps> = ({ folderId }) => {
  const { data, isLoading: isLoadingDetails, isFetching } = useGetFileDetailsQuery({ fse_id: folderId });

  const { isLoading, error, displayItems, totalPages, setCurrentPage, itemsPerPage, currentPage } = useDriveList({
    folderId,
  });

  return (
    <>
      {isFetching && <TopBarProgress />}
      <DriveBasePage
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        isLoading={isLoading || isLoadingDetails}
        error={error}
        displayItems={displayItems}
        isRootDirectory={false}
        data={data}
        folderId={folderId}
      />
    </>
  );
};
